import "./DealStructure.css";

import { Column, ErrorBox, Row } from "../../../../widget";
import { InvestmentDetails, Structure } from "./components";
import { useDealStructure } from "./useDealStructure";

export const DealStructure = (): JSX.Element => {
  const {
    errors,
    investments,
    selectedInvestment,
    selectedInvestmentKey,
    instrumentSelectData,
    associationSelectData,
    dealSpecificSchemaProperties,
    hasValidationError,
    setSelectedInvestmentKey,
    handleAddInvestment,
    handleUpdateInvestment,
    handleRemoveInvestment,
  } = useDealStructure();

  return (
    <>
      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <div className="DealStructureContainer">
        <Structure
          investments={investments}
          selectedInvestmentId={selectedInvestmentKey}
          associationSelectData={associationSelectData}
          instrumentSelectData={instrumentSelectData}
          onSelectInvestment={setSelectedInvestmentKey}
          onAddInvestment={handleAddInvestment}
          onRemoveInvestment={handleRemoveInvestment}
        />
        <InvestmentDetails
          selectedInvestment={selectedInvestment}
          hasInvestments={investments.length > 0}
          instrumentSelectData={instrumentSelectData}
          dealSpecificSchemaProperties={dealSpecificSchemaProperties}
          associationSelectData={associationSelectData}
          hasValidationError={hasValidationError}
          onAddInvestment={handleAddInvestment}
          onUpdateInvestment={handleUpdateInvestment}
        />
      </div>
    </>
  );
};
